import { DepartmentGroup } from '~/models/services/minifd';

export const STRING_DEPARTMENT_GROUP_MAP = {
    "Plant/River Group manager": DepartmentGroup.PLANT_MANAGER,
    "Primary Department": DepartmentGroup.PRIMARY_DEPARTMENT,
    "Asset Strategy": DepartmentGroup.ASSET_STRATEGY,
    "Energy Asset (Technology)": DepartmentGroup.ASSET_OPERATIONS,
    "Energy Asset Management": DepartmentGroup.ASSET_MANAGEMENT,
    "Business Controlling": DepartmentGroup.BUSINESS_CONTROLLING
} as const;
